import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
//import { Button, Form, Alert } from "react-bootstrap";
//import Container from 'react-bootstrap/Container';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Box from '@mui/material/Box';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Redirect } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import PhoneInput from 'react-phone-number-input/input';
import MaskedInput from 'react-text-mask';
import Alert from '@mui/material/Alert';
import * as actions from "../store/actions";
import * as actionTypes from "../store/actions/actionTypes";
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment/moment";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,

    },
    input: {
        borderRadius: 4,
        position: 'relative',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 5px 10px 5px',
        margin: theme.spacing(1),
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

function ResellerAddTicket(props){
    const classes = useStyles();
    //const [reseller, setReseller] = useState(0);
    //const [resellersList, setResellersList] = useState([]);
    //const [dealer, setDealer] = useState(0);
    //const [dealersList, setDealersList] = useState([]);
    //const [login, setLogin] = useState("");
    //const [password, setPassword] = useState("");
    //const [macAddress, setMacAddress] = useState("00:1A:79:");
    //const [macAddress, setMacAddress] = useState("");
    //const [ministra, setMinistra] = useState(false);
    //const [months, setMonths] = useState("3");
    const [issue, setIssue] = useState(0);
    const [description, setDescription] = useState("");
    const [isp, setIsp] = useState("");
    const [tested, setTested] = useState(0);
    const [device, setDevice] = useState("");
    //const [phone, setPhone] = useState("");
    //const [packageSelection, setPackageSelection] = useState(8);
    //const [packageListLive, setPackageListLive] = useState("");
    //const [packageListVod, setPackageListVod] = useState("");
    //const [selectedPackages, setSelectedPackages] = useState({subs:[]});
    //const [packagesList, setPackagesList] = useState(
    //    props.packages
    //);

    useEffect(() => {
        console.log('inside addticket');
        props.onInitializeAddTicket();
    }, []);

    useEffect(() => {
        if (props.isErrorAddTicket){
            var errorMessage = '' + props.isErrorAddTicket;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.isErrorAddTicket]);


    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    // const handleToggle = (event) => {
    //     //const target = event.target;
    //     //const value = target.type === 'checkbox' ? target.checked : target.value;
    //     //const name = target.name;
    //     //const key = target.key;
    //     //console.log('event name', event.target.name, ' value', event.target.value);
    //     const isChecked = event.target.checked;
    //     if (isChecked){
    //         setSelectedPackages({
    //             subs: [...selectedPackages.subs, event.target.value]
    //         });
    //     } else {
    //         const index = selectedPackages.subs.indexOf(event.target.value);
    //         selectedPackages.subs.splice(index,  1);
    //         setSelectedPackages({
    //             subs: selectedPackages.subs
    //         })
    //     }
    // };

    function validateForm() {
        //if (ministra){
        //    return login.length > 0 && login.length < 15 && password.length > 0 && password.length < 15 && description.length < 50 && phone.length < 15;
        //} else {
            return description.length >= 10 && description.length < 500;
        //}

    }

    function handleSubmit(event) {
        console.log('Inside handle submit');
        event.preventDefault();

        const data = {
            issue_type: issue,
            isp: isp,
            device: device,
            tested: tested,
            description: description,
        };
        if (tested === 0){
            let errorMessage = 'Please answer the question: Tested on another device?';
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        } else {
            props.onAddTicket(props.token, data);
        }
        // if (packageSelection === 3 && (selectedPackages.subs.length === packagesList.length || selectedPackages.subs.length < 1)){
        //     var errorMessage = 'If you want to select all packages, then just select ALL PACKAGES from package selection.';
        //     if (selectedPackages.subs.length < 1){
        //         errorMessage = 'Please select at least ONE package or select a pre-defined package from the package selection.';
        //     }
        //     props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        // } else if (reseller === 0) {
        //     let errorMessage = 'A reseller will need to be selected';
        //     props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        // } else if (dealer === 0){
        //     let errorMessage = 'Please select a dealer';
        //     props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        // } else {
        //     console.log('add submit data', data);
        //     props.onAddClient(props.token, data);
        // }

    }

    let addTicketredirect = null;
    if(props.isSuccessAddTicket){
        //props.onGetCredits(props.token);
        var successMessage = 'Added new ticket';
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});
        addTicketredirect = <Redirect to="/rsupport" />
    }

    // let displayMacAddress = null;
    // console.log('logging ministra: ', ministra);
    // if (!ministra){
    //     displayMacAddress = (
    //         <FormControl>
    //             <MaskedInput
    //                 mask={[/[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':', /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/]}
    //                 className={classes.input}
    //                 placeholder="Mac Address"
    //                 value={macAddress}
    //                 guide={true}
    //                 id="macAddress"
    //                 onChange={e => setMacAddress(e.target.value)}
    //             />
    //         </FormControl>
    //     );
    // }

    return (
        <div>
            {addTicketredirect}
            <Container>
                <Grid container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <Paper elevation={5}>
                            <Card>
                                <CardHeader
                                    title="Create Ticket"
                                    titleTypographyProps={{
                                        fontSize: 17,
                                        fontWeight: 'bold'
                                    }}
                                    subheaderTypographyProps={{
                                        fontSize: 14,
                                    }}
                                />
                                <Divider variant="middle" />
                                <CardContent>
                                    <form>
                                        <FormGroup row>
                                            <FormControl className={classes.formControl} fullWidth>
                                                <InputLabel id="select-months-label">Issue Type</InputLabel>
                                                <Select
                                                    id="months"
                                                    labelId="Select issue type"
                                                    value={issue}
                                                    onChange={e => setIssue(e.target.value)}
                                                >
                                                    <MenuItem value={0}>Channel Not Working/Freezing</MenuItem>
                                                    <MenuItem value={1}>Wrong Channel</MenuItem>
                                                    <MenuItem value={2}>New Channel request</MenuItem>
                                                    <MenuItem value={3}>New Movie/Series/Episode request</MenuItem>
                                                    <MenuItem value={4}>Audio issues</MenuItem>
                                                    <MenuItem value={5}>Other</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </FormGroup>
                                        <FormGroup row>
                                            <FormControl className={classes.formControl} fullWidth>
                                                <TextField
                                                    id="device"
                                                    error={device.length > 50}
                                                    value={device}
                                                    label="Device"
                                                    helperText={(device.length>500)?"Device name is too long":""}
                                                    onChange={e => setDevice(e.target.value)}
                                                    type="text"
                                                    fullWidth
                                                />
                                            </FormControl>
                                        </FormGroup>
                                        <FormGroup row>
                                            <FormControl className={classes.formControl} fullWidth>
                                                <TextField
                                                    id="isp"
                                                    error={isp.length > 50}
                                                    value={isp}
                                                    label="Internet Service Provider"
                                                    helperText={(isp.length>50)?"ISP name is too long":""}
                                                    onChange={e => setIsp(e.target.value)}
                                                    type="text"
                                                    fullWidth
                                                />
                                            </FormControl>
                                        </FormGroup>
                                        <FormGroup row>
                                            <FormControl className={classes.formControl} fullWidth>
                                                <InputLabel id="tested-label">Tested on another device?</InputLabel>
                                                <Select
                                                    id="tested"
                                                    labelId="Tested on another device?"
                                                    value={tested}
                                                    onChange={e => setTested(e.target.value)}
                                                >
                                                    <MenuItem value={0}>Select</MenuItem>
                                                    <MenuItem value={1}>Yes</MenuItem>
                                                    <MenuItem value={2}>No</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </FormGroup>
                                        <Box>
                                        <Alert variant="filled" severity="warning">Please provide a <strong>detailed</strong> description. A generalized and short description may delay the resolution of this ticket.</Alert>
                                        </Box>
                                        <FormGroup row>
                                            <FormControl className={classes.formControl} fullWidth>
                                                <TextField
                                                    id="description"
                                                    error={description.length > 500}
                                                    value={description}
                                                    label="Description"
                                                    helperText={(description.length>500)?"Description is too long":""}
                                                    onChange={e => setDescription(e.target.value)}
                                                    type="text"
                                                    maxRows={4}
                                                    multiline
                                                    fullWidth
                                                />
                                            </FormControl>
                                        </FormGroup>    
                                    </form>
                                </CardContent>
                                <CardActions>
                                        <Button
                                            block
                                            disabled={!validateForm() || props.isLoadingAddClient}
                                            type="submit"
                                            onClick={handleSubmit}
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            fullWidth
                                        >
                                            {props.isLoadingAddClient
                                                ? spinner
                                                : 'Submit Ticket'}
                                        </Button>
                                </CardActions>
                            </Card>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        //onGetPackageList: (token) => dispatch(actions.packagesListAdmin(token)),
        //onGetDealerList: (token) => dispatch(actions.dealerListAdmin(token)),
        onInitializeAddTicket: () => dispatch(actions.initializeAddTicket()),
        onAddTicket: (token, data) => dispatch(actions.addTicketReseller(token, data)),
        onGetCredits: (token) => dispatch(actions.creditsUser(token)),
        //onGetShortResellerList: (token) => dispatch(actions.resellerListShortAdmin(token)),
        //onGetdealerListShortAdmin: (token) => dispatch(actions.dealerListShortAdmin(token)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        isLoadingAddTicket: state.addTicket.loading,
        isErrorAddTicket: state.addTicket.error,
        isSuccessAddTicket: state.addTicket.ticket
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(ResellerAddTicket);